import { message } from "antd";
import axiosInstance from "../shared/axios";

const getAllDrafs = async (params) => {
  try {
    const result = await axiosInstance.get("/draft/viewAll", {
      params: {
        name: params?.name || "",
        type: params?.type ?? null,
        fromDate: params?.fromDate || "",
        toDate: params?.toDate || "",
        follow_up_status: params?.follow_up_status ?? null,
        serviceID: params?.serviceID ?? null,
        client_priority: params?.client_priority ?? null,
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading drafts");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading drafts",
    );
    return { data: [], total: 0 };
  }
};

const addEditDraft = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/draft/update" : "/draft/create",
      { ...payload, id: id || null },
    );

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save drafts",
    };
  }
};

const deleteDraft = async (id) => {
  try {
    const result = await axiosInstance.delete(`/draft/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete draft",
    };
  }
};

const updateDraftStatus = async ({ id, status }) => {
  try {
    let result = await axiosInstance?.post(`/draft/updateStatus`, {
      id,
      follow_up_status: status,
    });
    if (result?.status === 200 && result?.data?.success) {
      return result?.data;
    } else {
      message.error("error", "Error while loading update draft status");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading update draft status");
    return null;
  }
};

const getAllDrafsNotes = async (draft_id) => {
  try {
    const result = await axiosInstance.get(`/draft/viewAllDraftNotes`, {
      params: {
        draft_id,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
      };
    } else {
      message.error("Error while loading draft notes");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading draft notes",
    );
    return { data: [], total: 0 };
  }
};

const addEditDraftNote = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/draft/updateDraftNote" : "/draft/addDraftNote",
      { ...payload, id: id || null },
    );

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save draft note",
    };
  }
};

const deleteDraftNote = async (id) => {
  try {
    const result = await axiosInstance.delete(`/draft/deleteDraftNote/${id}`);
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete draft note",
    };
  }
};

const getCallHistory = async (draft_id) => {
  try {
    const result = await axiosInstance.get(`/draft/viewCallAgainHistory`, {
      params: {
        draft_id,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
      };
    } else {
      message.error("Error while loading draft call history");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message ||
        "Error while loading draft call history",
    );
    return { data: [], total: 0 };
  }
};

export const draftapi = {
  getAllDrafs,
  addEditDraft,
  deleteDraft,
  updateDraftStatus,
  getAllDrafsNotes,
  addEditDraftNote,
  deleteDraftNote,
  getCallHistory,
};
